import { useQuery } from '@apollo/client'

import { IPrepItemBatchTypesType, getPrepItemBatchTypes } from '../gql'

const usePrepItemBatchTypes = () => {
  const { data, loading } = useQuery<IPrepItemBatchTypesType>(
    getPrepItemBatchTypes,
  )

  return {
    batchTypes: data?.getPrepItemBatchTypes.nodes || [],
    loading,
  }
}

export default usePrepItemBatchTypes
